import { resolveExecutionEnvironment } from '@/core/infrastructure/environment';

/** @type {import('@/core/infrastructure/environment/ExecutionEnvironment').default|null} */
let executionEnvironment = null;

/**
 * @returns {import('@/core/infrastructure/environment/ExecutionEnvironment').default}
 */
export function getExecutionEnvironment() {
  return executionEnvironment ?? resolveExecutionEnvironment();
}

/**
 * Registers global access to the resolved execution environment.
 * Resolved once at app startup; values do not change during the session.
 */
export default {
  install(Vue) {
    executionEnvironment = resolveExecutionEnvironment();
    const config = executionEnvironment.toConfig();

    /**
     * Execution environment resolved from `location.hostname`.
     * Use for environment checks (`isProduction()`, `isDevelopment()`, etc.).
     * @type {import('@/core/infrastructure/environment/ExecutionEnvironment').default}
     */
    Vue.prototype.$appEnvironment = executionEnvironment;

    /**
     * Environment-specific settings (snapshot for this session).
     * @returns {{
     *   environment: 'production'|'staging'|'development',
     *   apiBase: string,
     *   milbonIdBase: string,
     * }}
     * @description
     * - `environment` — deployment target (production / staging / development)
     * - `apiBase` — Style Stock API base URL (e.g. dashboard `fetch`)
     * - `milbonIdBase` — Milbon ID (salon member) API base URL
     */
    Vue.prototype.$appConfig = () => config;
  },
};
